(($, Drupal, drupalSettings) => {
  const get = (selector, context) => {
    return context.querySelectorAll(selector);
  }

  Drupal.behaviors.serviceListing = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('.service-container'))
      //   .once('service-tree')
      //   .each( (index, item) => {
      $(once('service-tree', '.service-container'))
        .each( (index, item) => {
          item.querySelectorAll('.sub-service-container').forEach( subLevel => subLevel.style.display = "none" );
          var options = item.querySelector('.options');
          if (options) {
            Drupal.behaviors.serviceListing.toggleListHandler(options);
          }

        });
    },

    toggleListHandler: domElm => {
      domElm.addEventListener('click', e => {
        var parent = e.target.parentNode, depth = '';
        parent.classList.toggle('open');
        parent.classList.forEach( classes => {
          if (classes.indexOf('sc-depth') > -1 ){
            depth = classes;
          }
        });
        $(parent.querySelectorAll('.'+depth)).slideToggle();
      });

    },
  }
})(jQuery, Drupal, drupalSettings);
